import { Avatar, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconApproved from "../../../assets/images/receiveSalary/check-circle.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";
export const formatTableValue = (value, key, code, id, submit) => {
  switch (key) {
    case "contact":
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {value &&
            value?.map((item, index) => (
              <Text key={index}>
                {typeof item === "undefined" ? "-" : item}
              </Text>
            ))}
        </Flex>
      );
    case "bankInfo":
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {value &&
            value?.map((item, index) => (
              <Text key={index}>
                {typeof item === "undefined" ? "-" : item}
              </Text>
            ))}
        </Flex>
      );
    case "identificationNumberInfo":
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {value &&
            value?.map((item, index) => (
              <Text key={index}>
                {typeof item === "undefined" ? "-" : item}
              </Text>
            ))}
        </Flex>
      );
    case "avatar":
      return (
        <Avatar
          src={`${process.env.REACT_APP_BACKEND_API}/${value}`}
          cursor={"pointer"}
        />
      );
    case "status":
      const status = !value ? "Đang làm việc" : "Dừng làm việc";
      return (
        <Text
          color={
            value ? "var(--text-red-employee)" : "var(--color-status-employ)"
          }
        >
          {status}
        </Text>
      );
    case "isProfileCompleted":
      let content;
      if (!value) {
        content = <>Chưa hoàn thiện hồ sơ</>;
      } else {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>
                Đã hoàn thiện hồ sơ
              </Text>
            </Flex>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"100%"}>
          {content}
        </Flex>
      );
    case "referralSource": {
      const referralSourceLabels = {
        COMPANY: "Nguồn công ty",
        PERSONAL: "Nguồn cá nhân",
      };

      return (
        <Text
          color={
            value
              ? "var(--color-status-employ)"
              : "var(--color-label-employee)"
          }
        >
          {referralSourceLabels[value] || "Chưa có nguồn"}
        </Text>
      );
    }
    case "isBrokerDebtCertificate":
      let contentBrokerDebtCertificate;
      if (!value) {
        contentBrokerDebtCertificate = <>Chưa có</>;
      } else {
        contentBrokerDebtCertificate = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>
                Đã có
              </Text>
            </Flex>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"100%"}>
          {contentBrokerDebtCertificate}
        </Flex>
      );

    case "idCardFrontImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt trước của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "idCardBackImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt sau của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "vneidFrontImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh VNeID mặt trước của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "vneidBackImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh VNeID mặt sau của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    default:
      return <Text cursor={"pointer"}>{value}</Text>;
  }
};

export const downloadImageOrZip = async (input, name) => {
  const URL = baseURL + "/";
  if (typeof input === "string") {
    // Trường hợp 1 URL đơn
    try {
      const response = await fetch(URL + input);
      const blob = await response.blob();
      let filename;
      if (name) {
        filename = name.endsWith(".jpg") ? name : name + ".jpg";
      } else {
        const original = input.split("/").pop()?.split(".")[0] || "image";
        filename = `${original}.jpg`;
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error("Lỗi khi tải ảnh:", error);
    }
  } else if (Array.isArray(input)) {
    // Trường hợp mảng URL → zip
    const zip = new JSZip();
    for (const url of input) {
      try {
        const response = await fetch(URL + url);
        const blob = await response.blob();

        // Ép ảnh thành .jpg bất kể đuôi thật
        const originalName = url.split("/").pop()?.split(".")[0] || "image";
        const filename = `${originalName}.jpg`;

        zip.file(filename, blob);
      } catch (error) {
        console.error("Lỗi khi tải ảnh:", url, error);
      }
    }
    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${name ? name : "anh_hdmb.zip"}`);
    } catch (zipError) {
      console.error("Lỗi khi tạo file ZIP:", zipError);
    }
  } else {
    console.warn("Input không hợp lệ: phải là chuỗi hoặc mảng chuỗi.");
  }
};
